/** Build resource detail URL, optionally preserving hub context (survives refresh). */
export function buildResourcePath(resourceSlug: string, fromHubSlug?: string): string {
  const base = `/resources/${resourceSlug}`;
  if (!fromHubSlug) return base;
  return `${base}?fromHub=${encodeURIComponent(fromHubSlug)}`;
}

export function parseHubContext(search: string): string | null {
  const params = new URLSearchParams(search);
  const slug = params.get('fromHub')?.trim() || params.get('fromToolkit')?.trim();
  return slug || null;
}

export type ResourceLibraryFacet = 'audiences' | 'clinicalAreas' | 'topics';

export type CatalogFilterFacet = 'audience' | 'clinicalArea' | 'topic' | 'contentType';

export function resourceLibraryFilterHref(facet: ResourceLibraryFacet, value: string): string {
  const params = new URLSearchParams();
  params.set(facet, value);
  return `/resources?${params.toString()}`;
}

export function catalogFilterHref(facet: CatalogFilterFacet, value: string): string {
  const params = new URLSearchParams();
  params.set(facet, value);
  return `/resources?${params.toString()}`;
}
